export default "__VITE_ASSET__5a878bf3__"